import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './cookieBanner.css';

export default function CookieBanner() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already dismissed the cookie banner
    const cookieNotice = localStorage.getItem('cookieNotice');
    if (!cookieNotice) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('cookieNotice', 'acknowledged');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-banner">
      <div className="cookie-banner-content">
        <div className="cookie-banner-text">
          <h3>{t('cookies.title', 'Cookies Information')}</h3>
          <p>
            {t('cookies.message', 'This website uses cookies to provide functionality.')}
          </p>
        </div>
        <div className="cookie-banner-buttons">
          <button
            className="cookie-banner-button cookie-banner-button-close"
            onClick={handleClose}
          >
            {t('cookies.close', 'Close')}
          </button>
        </div>
      </div>
    </div>
  );
}
